import {UseCasesBlockSectionProps} from "../types/types";

const UseCasesSectionBlk = ({
  title,
  description,
  videoBg,
}: UseCasesBlockSectionProps) => {
  return (
    <>
      <div
        className={`use-cases-section-blk relative overflow-hidden`}
        style={!videoBg ? {minHeight: "200px"} : {}}>
        {videoBg && (
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute top-0 left-0 w-full h-full object-cover">
            <source
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/videos/video-background.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        )}

        {/* Overlay Images */}
        {videoBg && (
          <div className="use-cases-section-overlay absolute inset-0 flex justify-between items-center pointer-events-none">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/left-wand-pattern.png"
              alt="Left Wand Pattern"
              className="left-wand-image animate-fade-in-left"
            />
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/right-wand-pattern.png"
              alt="Right Wand Pattern"
              className="right-wand-image animate-fade-in-right"
            />
          </div>
        )}

        {/* Content */}
        <div className="main-container-blk relative z-10 text-center py-12">
          <h1 className="text-4xl font-bold mb-4 transition-opacity duration-700">
            {title}
          </h1>
          <p className="text-lg max-w-2xl mx-auto transition-opacity duration-700 delay-100">
            {description}
          </p>
        </div>
      </div>

      <div className="bottom-hero-pattern-use-cases-blk"></div>
    </>
  );
};

export default UseCasesSectionBlk;
